import { render, staticRenderFns } from "./StadiumCreateForm.vue?vue&type=template&id=66c8dab6&"
import script from "./StadiumCreateForm.vue?vue&type=script&lang=js&"
export * from "./StadiumCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports